import { useState, type MouseEvent } from 'react';
import { Card, CardBody, Stars, TextLink, Typography } from 'darrius';

import styles from './Recomendations.module.scss';

interface IRecomendationItem {
  name: string;
  description: string;
  rating: number;
}

interface IRecomendationsProps {
  limit: number;
  recomendations: {
    id: string;
    title: string;
    items: IRecomendationItem[];
    totalPage: number;
  };
}

const DEFAULT_PAGE = 1;
const LIMIT_RECOMENDATIONS = 3;

export const Recomendations = ({
  recomendations,
  limit = LIMIT_RECOMENDATIONS,
}: IRecomendationsProps) => {
  const { id, items, title } = recomendations;
  const [pageCount, setPageCount] = useState(DEFAULT_PAGE);
  const [recomendationsList, setRecomendationsList] = useState(
    items.slice(0, 3)
  );
  const allRecomendations = items;

  const remaningRecomendations =
    allRecomendations.length - recomendationsList.length;

  const showButton = allRecomendations.length > limit;

  async function handleShowNewRecomendation(evt: MouseEvent) {
    evt.preventDefault();
    const currentPage = pageCount + 1;
    setRecomendationsList(allRecomendations.slice(0, currentPage * limit));
    setPageCount(currentPage);
  }

  function handleResetInitialRecomendation(evt: MouseEvent) {
    evt.preventDefault();
    setPageCount(DEFAULT_PAGE);
    setRecomendationsList((oldState) => [...oldState.slice(0, limit)]);
  }

  return (
    <section className="recomendations space-top" id={id}>
      <Typography.Subtitle size="l" className={styles['recomendations__title']}>
        {title}
      </Typography.Subtitle>
      <div className="recomendations__list">
        {recomendationsList.map((recomendation) => (
          <Card
            key={recomendation.name}
            className={`recommendations__item space-bottom ${styles['recommendations__item']}`}
          >
            <CardBody>
              <Typography.Text>
                <b>{recomendation.name}</b>
              </Typography.Text>
              <Typography.Text>{recomendation.description}</Typography.Text>
              <Stars rating={recomendation.rating} size="small" />
            </CardBody>
          </Card>
        ))}
      </div>
      {showButton && remaningRecomendations <= 0 ? (
        <TextLink
          text="Exibir menos"
          url="#recomendations"
          onClick={(evt) => handleResetInitialRecomendation(evt)}
          className="recommendations__show-less"
        />
      ) : null}

      {showButton && remaningRecomendations > 0 ? (
        <TextLink
          text={`Comentários restantes (${remaningRecomendations})`}
          url=""
          onClick={async (evt) => handleShowNewRecomendation(evt)}
          className="recommendations__show-more"
        />
      ) : null}
    </section>
  );
};
